import gql from 'graphql-tag';

import * as fragments from '../fragments';

export const USERS = gql`
  query Users {
    users {
      ...userFields
      followers {
        ...identificationFields
      }
      following {
        ...identificationFields
      }
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
  ${fragments.USER_FRAGMENT}
`;

export const CURRENT_USER = gql`
  query CurrentUser {
    currentUser {
      ...userFields
      followers {
        ...identificationFields
      }
      following {
        ...identificationFields
      }
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
  ${fragments.USER_FRAGMENT}
`;

export const USER_BY_ID = gql`
  query UserById($userId: ID!) {
    userById(userId: $userId) {
      ...userFields
      credentials {
        profession
        location
        isTopWriter
        education
      }
      description
      isDeceased
      addedQuestions {
        id
      }
      addedAnswers {
        id
      }
      addedBlogPosts {
        id
      }
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
  ${fragments.USER_FRAGMENT}
`;
